import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ZoomToFitIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ZoomToFit",
    children: /*#__PURE__*/_jsx("path", {
      d: "M8.088 10.945v10.11a2.86 2.86 0 0 0 2.857 2.857h10.11a2.86 2.86 0 0 0 2.857-2.857v-10.11a2.86 2.86 0 0 0-2.857-2.857h-10.11a2.86 2.86 0 0 0-2.857 2.857m13.538 0v10.11a.573.573 0 0 1-.571.571h-10.11a.573.573 0 0 1-.571-.571v-10.11c0-.314.257-.571.571-.571h10.11c.314 0 .571.257.571.571M3.429 13.275c.631 0 1.142-.512 1.142-1.143V5.714c0-.63.513-1.143 1.143-1.143h6.418a1.142 1.142 0 1 0 0-2.285H5.714a3.43 3.43 0 0 0-3.428 3.428v6.418c0 .631.51 1.143 1.143 1.143M26.286 2.286h-6.418a1.142 1.142 0 1 0 0 2.285h6.418c.63 0 1.143.513 1.143 1.143v6.418a1.142 1.142 0 1 0 2.285 0V5.714a3.43 3.43 0 0 0-3.428-3.428M12.132 27.429H5.714c-.63 0-1.143-.513-1.143-1.143v-6.418a1.142 1.142 0 1 0-2.285 0v6.418a3.43 3.43 0 0 0 3.428 3.428h6.418a1.142 1.142 0 1 0 0-2.285M28.571 18.725c-.631 0-1.142.512-1.142 1.143v6.418c0 .63-.513 1.143-1.143 1.143h-6.418a1.142 1.142 0 1 0 0 2.285h6.418a3.43 3.43 0 0 0 3.428-3.428v-6.418c0-.631-.51-1.143-1.143-1.143"
    })
  }));
};
ZoomToFitIcon.displayName = 'ZoomToFitIcon';